/* eslint-disable max-lines-per-function, max-params */
export const pluralize = (count, noun, suffix = "s", stripNumber = false) => {
  const parsedCount = parseInt(count, 10);
  if (stripNumber) {
    return `${noun}${parsedCount !== 1 ? suffix : ""}`;
  }
  return `${count} ${noun}${parsedCount !== 1 ? suffix : ""}`;
};

export const capitalize = words => {
  const wordsArray = words.split(" ");
  let i = 0;

  const result = [];

  while (i < wordsArray.length) {
    const word = wordsArray[i];
    const firstLetter = word[0].toUpperCase();
    const restOfLetters = word.slice(1);

    result.push(firstLetter + restOfLetters);
    i += 1;
  }

  return result.join(" ");
};

export const initials = word =>
  word
    .split(" ")
    .slice(0, 2)
    .map(el => el[0])
    .join("");
